import { MdExpandMore } from "react-icons/md";
import { Transaction } from "./Transaction";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
    fetchPaginationTransactions,
    fetchTransactions,
} from "./../features/transaction/transactionSlice";
import { useNavigate } from "react-router-dom";

export const Transactions = () => {
    const dispatch = useDispatch();
    const { transactions, isLoading, isError } = useSelector(
        (state) => state.transaction
    );
    const { pagination } = useSelector((state) => state.pagination) || {};

    const navigation = useNavigate();

    const more = () => {
        navigation("/transactions");
        const { currentPage, limit } = pagination;
        dispatch(fetchPaginationTransactions({ currentPage, limit }));
    };

    useEffect(() => {
        dispatch(fetchTransactions());
    }, [dispatch]);

    let content = null;

    if (isLoading)
        content = <p className="text-sm text-green-600 py-4">Loading...</p>;

    if (!isLoading && isError)
        content = (
            <p className="text-red-600 text-sm py-4">
                There was an error occured
            </p>
        );

    if (!isLoading && !isError && transactions?.length > 0) {
        content = transactions
            .map((transaction) => {
                return (
                    <Transaction
                        key={transaction.id}
                        transaction={transaction}
                    />
                );
            })
            .reverse()
            .slice(0, 5);
    }
    if (!isLoading && !isError && transactions?.length === 0)
        content = (
            <p className="text-red-600 text-sm py-4">
                There have not transactions
            </p>
        );

    return (
        <>
            <div className="md:w-4/12 mx-auto mt-6">
                <p className="text-sm text-blue-600 text-center mb-6">
                    Our Transactions
                </p>

                {content}

                <button
                    onClick={more}
                    className="h-8 px-4 text-sm bg-green-200 text-green-600 rounded hover:bg-green-300 duration-200 inline-flex items-center gap-2"
                >
                    <MdExpandMore /> More
                </button>
            </div>
        </>
    );
};
